import React from 'react'
import Listcourse from '../../Components/tutor/Listcourse'

function Listcourses() {
  return (
   
      <>
      <Listcourse/>
      </>
      
   
  )
}

export default Listcourses
